/* Utility helpers for agenda-related operations */

/**
 * Returns the agenda key as a string, or null if unavailable.
 * @param {object} agenda - The agenda object.
 * @returns {string|null}
 */
export const getAgendaKey = (agenda) => {
  return agenda?.CODAGENDA ? String(agenda.CODAGENDA) : null;
};

/**
 * Retrieves the doctor ID from agenda or laudo.
 * @param {object} agenda - The agenda object.
 * @param {object} laudo - The laudo object (fallback).
 * @returns {string|undefined}
 */
export const getDoctorId = (agenda, laudo) => {
  return agenda?.CODMED || laudo?.CODMED;
};

/**
 * Determines if the agenda is valid (has a CODAGENDA).
 * @param {object} agenda - The agenda object.
 * @returns {boolean}
 */
export const isAgendaValid = (agenda) => {
  return Boolean(agenda && agenda.CODAGENDA);
};
